import * as React from 'react';
import styled from 'styled-components';
import { flexbox, FlexboxProps } from 'styled-system';
import Box, { IBoxProps } from '../Box';

export interface IGridProps extends IBoxProps, FlexboxProps {}

const Grid: React.FC<IGridProps> = styled(Box).attrs(() => ({
  display: 'flex'
}))`
  ${flexbox}
`;

Grid.displayName = 'Grid';

export default Grid;
